import { FleetChecklistType } from "../models/fleet-checklist";

export const FLEET_TYPES: Record<string, string> = {
  [FleetChecklistType.INTERNO]: 'Validación Interna',
  [FleetChecklistType.EXTERNO]: 'Validación Externa',
  [FleetChecklistType.MOVILBUS]: 'Validación Movilbus',
  [FleetChecklistType.DIAZ]: 'Validación Diaz',
}
